import { createRef, Component } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';

import './Backdrop.scss';

const ESC_KEY = 27;

class Backdrop extends Component {
  backdropRef = createRef();

  componentDidMount() {
    this.container = document.querySelector('body');
    this.el = document.createElement('div');

    if (this.props.closeOnClick) {
      this.el.addEventListener('click', this.handleCloseOnClick);
    }
    this.container.appendChild(this.el);

    window.addEventListener('keydown', this.handleCloseOnKeyDown);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.isOpen) {
      this.el.classList.add('backdrop');
      this.container.classList.add('backdrop--open');
    } else {
      this.el.classList.remove('backdrop');
      this.container.classList.remove('backdrop--open');
    }
  }

  componentWillUnmount() {
    this.container.removeChild(this.el);
    window.removeEventListener('keydown', this.handleCloseOnKeyDown);
  }

  handleCloseOnClick = e => {
    if (e.target === this.el) {
      this.props.handleClose();
    }
  };

  handleCloseOnKeyDown = e => {
    if (e.keyCode === ESC_KEY && this.props.isOpen) {
      this.props.handleClose();
    }
  };

  handleBackdropClick = e => {
    e && e.stopPropagation();
    if (e.target === this.backdropRef.current) {
      this.props.handleClose();
    }
  };

  render() {
    return (
      this.props.isOpen &&
      createPortal(
        <div
          ref={this.backdropRef}
          role="button"
          tabIndex={-1}
          onClick={this.handleBackdropClick}
        >
          {this.props.children}
        </div>,
        this.el
      )
    );
  }
}

Backdrop.propTypes = {
  isOpen: PropTypes.bool,
  closeOnClick: PropTypes.bool,
  handleClose: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

Backdrop.defaultProps = {
  isOpen: false,
  closeOnClick: false,
  handleClose: () => {}
};

export default Backdrop;
